/**
 * iVoodoo Komponenten-Runde (Block B, 08.09.2026)
 * - Drawer (Mobilmenue, Warenkorb, Suche, Filter) und Lightbox:
 *   Dialog-Semantik, Fokusfalle, Fokus-Rueckkehr (wie Abhol-Panel).
 * - Sticky-Kaufleiste: Kauf-Button oeffnet bei Varianten das Panel;
 *   Body-Klasse, solange die Leiste sichtbar ist („Nach oben“ weicht).
 * - Footer im Viewport: Body-Klasse (hCaptcha-Badge weicht).
 * - Footer-Akkordeon: aria-expanded + Aufklappen ueber die Liste.
 * Keine Menue-, Warenkorb- oder Checkout-Logik wird veraendert.
 */
(function () {
  'use strict';
  if (window.ivUiComponentsReady) return;
  window.ivUiComponentsReady = true;

  var FOCUSABLE = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex]';
  var PANEL_SELECTOR = '.side-panel';
  var LABELS = { 'Cart-Drawer': 'Warenkorb', 'Search-Drawer': 'Suche', 'Facet-Drawer': 'Filtern und sortieren', 'Product-Drawer': 'Produkt', 'Product-Information-Drawer': 'Produktinformationen', 'Pickup-Availability': 'Abholung' };

  function visible(el) {
    if (!el || !el.isConnected || el.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    if (el.matches(':disabled') || el.getAttribute('aria-disabled') === 'true') return false;
    var rect = el.getBoundingClientRect();
    var style = getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  }

  function focusables(root) {
    return Array.from(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.tabIndex >= 0 && visible(el);
    });
  }

  function focus(el) {
    if (!el || !visible(el)) return;
    try { el.focus({ preventScroll: true }); } catch (error) { el.focus(); }
  }

  /* One state owner for panels, the mobile header dialog and PhotoSwipe.
     Existing components still open through their own class/details state. */
  function watchDialogs() {
    var entries = [];
    var stack = [];
    var locks = new Map();
    var lastAction = null;
    var redirecting = false;

    function isOpen(entry) {
      if (!entry.root.isConnected) return false;
      if (entry.kind === 'menu') return entry.details.open;
      if (entry.kind === 'lightbox') return entry.root.classList.contains('pswp--open');
      return entry.root.classList.contains('active') || entry.root.classList.contains('open') || entry.root.hasAttribute('open');
    }

    function top() { return stack[stack.length - 1] || null; }

    function label(panel) {
      if (panel.hasAttribute('aria-label') || panel.hasAttribute('aria-labelledby')) return;
      var heading = panel.querySelector('.side-panel-header .h6, .side-panel-header h2, .side-panel-header h3');
      if (heading && heading.textContent.trim()) {
        if (!heading.id) heading.id = 'iv-dialog-title-' + entries.length;
        panel.setAttribute('aria-labelledby', heading.id);
      } else {
        panel.setAttribute('aria-label', LABELS[panel.id] || 'Dialog');
      }
    }

    function register() {
      Array.from(document.querySelectorAll(PANEL_SELECTOR + ', .pswp')).forEach(function (root) {
        if (entries.some(function (entry) { return entry.root === root; })) return;
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        if (!root.hasAttribute('tabindex')) root.tabIndex = -1;
        label(root);
        if (!root.matches('.active, .open, [open], .pswp--open')) {
          root.inert = true;
          root.setAttribute('aria-hidden', 'true');
        }
        entries.push({ root: root, kind: root.matches('.pswp') ? 'lightbox' : 'panel', active: false });
      });
      var header = document.querySelector('theme-header');
      var details = header && header.querySelector('.mobile-toggle-wrapper');
      if (details && !entries.some(function (entry) { return entry.kind === 'menu' && entry.root === header; })) {
        entries.push({ root: header, kind: 'menu', details: details, active: false, savedRole: header.getAttribute('role'), savedLabel: header.getAttribute('aria-label') });
      }
    }

    function isolate() {
      locks.forEach(function (wasInert, node) { node.inert = wasInert; });
      locks.clear();
      entries.forEach(function (entry) {
        if (entry.kind === 'menu') return;
        entry.root.inert = !entry.active;
        if (entry.active) entry.root.removeAttribute('aria-hidden');
        else entry.root.setAttribute('aria-hidden', 'true');
      });
      var active = top();
      if (!active) return;
      var branch = active.root;
      while (branch && branch !== document.body) {
        var parent = branch.parentElement;
        if (!parent) break;
        Array.from(parent.children).forEach(function (sibling) {
          // The inert page stays inactive; the non-focusable backdrop must still close the dialog.
          if (sibling === branch || sibling.matches('script, style, link, meta, .click-capture')) return;
          locks.set(sibling, sibling.inert);
          sibling.inert = true;
        });
        branch = parent;
      }
    }

    function firstFocus(entry) {
      if (entry.kind === 'menu') return entry.root.querySelector('#mobile-menu');
      var preferred = entry.kind === 'lightbox' ? entry.root.querySelector('.pswp__button--close') : entry.root.querySelector('input[type="search"], .side-panel-close__button, button.side-panel-close');
      return preferred && visible(preferred) ? preferred : focusables(entry.root)[0] || entry.root;
    }

    function sync() {
      var previous = top();
      var changed = false;
      var closed = [];
      entries.forEach(function (entry) {
        var open = isOpen(entry);
        if (open === entry.active) return;
        changed = true;
        entry.active = open;
        if (open) {
          var current = document.activeElement;
          var action = lastAction && Date.now() - lastAction.time < 2000 ? lastAction.target : null;
          entry.opener = current && current !== document.body && !entry.root.contains(current) ? current : action && visible(action) && !entry.root.contains(action) ? action : entry.kind === 'menu' ? entry.details.querySelector('summary') : null;
          if (entry.kind === 'menu') {
            entry.root.setAttribute('role', 'dialog');
            entry.root.setAttribute('aria-modal', 'true');
            entry.root.setAttribute('aria-label', entry.root.querySelector('#mobile-menu').getAttribute('aria-label'));
          }
          stack.push(entry);
        } else {
          stack = stack.filter(function (item) { return item !== entry; });
          closed.push(entry);
          if (entry.kind === 'menu') {
            if (entry.savedRole) entry.root.setAttribute('role', entry.savedRole); else entry.root.removeAttribute('role');
            if (entry.savedLabel) entry.root.setAttribute('aria-label', entry.savedLabel); else entry.root.removeAttribute('aria-label');
            entry.root.removeAttribute('aria-modal');
          }
        }
      });
      if (!changed) return;
      isolate();
      var active = top();
      if (closed.indexOf(previous) !== -1) {
        var opener = previous.opener;
        previous.opener = null;
        window.setTimeout(function () {
          if (top() !== active) return;
          if (opener && visible(opener) && (!active || active.root.contains(opener))) focus(opener);
          else if (active) focus(firstFocus(active));
        }, 30);
      } else if (active && active !== previous) {
        window.setTimeout(function () { if (top() === active && isOpen(active)) focus(firstFocus(active)); }, 180);
      }
    }

    function close(root) {
      var entry = entries.find(function (item) { return item.root === root; });
      if (!entry) return false;
      if (!isOpen(entry)) return true;
      if (entry.kind === 'lightbox') {
        if (root.ivPhotoSwipe) root.ivPhotoSwipe.close();
      } else if (entry.kind === 'menu') {
        entry.details.open = false;
        entry.details.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      } else {
        root.classList.remove('active', 'open');
        root.removeAttribute('open');
        if (root.id === 'Product-Drawer') {
          document.body.classList.remove('open-cc--product');
          window.setTimeout(function () {
            var content = root.querySelector('#Product-Drawer-Content');
            if (content && !isOpen(entry)) content.innerHTML = '';
          }, 260);
        }
        if (!entries.some(function (item) { return item.kind === 'panel' && item.root.id !== 'Product-Drawer' && isOpen(item); })) document.body.classList.remove('open-cc');
      }
      sync();
      return true;
    }

    register();
    entries.forEach(function (entry) { if (entry.kind !== 'menu' && !isOpen(entry)) { entry.root.inert = true; entry.root.setAttribute('aria-hidden', 'true'); } });
    window.ivDialogs = {
      close: close,
      activeRoot: function () { return top() && top().root; },
      replaceOpener: function (previous, replacement) {
        entries.forEach(function (entry) { if (entry.opener === previous) entry.opener = replacement; });
      }
    };
    document.addEventListener('click', function (event) {
      var target = event.target.closest('a[href], button, summary, facet-toggle, quick-view, [role="button"]');
      if (target) lastAction = { target: target, time: Date.now() };
    }, true);
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      var closeButton = event.target.closest('side-panel-close, button.side-panel-close');
      if (closeButton) {
        if (close(closeButton.closest('.side-panel'))) event.preventDefault();
      } else if (event.target.closest('.click-capture--product')) {
        close(document.getElementById('Product-Drawer'));
      } else if (event.target.closest('.click-capture')) {
        var active = top();
        if (active && active.kind === 'panel') close(active.root);
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.defaultPrevented) return;
      var active = top();
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(active.root);
      } else if (event.key === 'Tab') {
        var list = focusables(active.root);
        var current = document.activeElement;
        if (!list.length) { event.preventDefault(); focus(active.root); return; }
        if (event.shiftKey && (current === list[0] || list.indexOf(current) === -1)) {
          event.preventDefault(); focus(list[list.length - 1]);
        } else if (!event.shiftKey && (current === list[list.length - 1] || !active.root.contains(current))) {
          event.preventDefault(); focus(list[0]);
        }
      }
    });
    document.addEventListener('focusin', function (event) {
      sync();
      var active = top();
      if (!active || active.root.contains(event.target) || redirecting) return;
      redirecting = true;
      focus(firstFocus(active));
      redirecting = false;
    });
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return mutation.type === 'childList'; })) register();
      sync();
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open'] });
    sync();
  }

  /* Fixierte Leisten am unteren Rand: Kaufleiste der Produktseite und - seit 18.09.2026 (M3) -
     die Zusammenfassungsleiste des Reparatur-Konfigurators. Beide setzen denselben Schalter
     body.iv-sticky-visible, der den "Nach oben"-Knopf ausblendet (Regel in
     assets/ivoodoo-ui-components.css). Grund fuer M3: Der Knopf lag ueber "Weiter" bzw.
     "Zur Buchung" und fing den Tipp ab; ein hoeherer z-index half nachweislich nicht, weil
     #main-content per clip-path einen eigenen Stapelkontext aufmacht (app.css). */
  function watchSticky() {
    var sticky = document.querySelector('.product-add-to-cart-sticky');
    var repair = document.querySelector('.repair-configurator__mobile-summary');
    if (!sticky && !repair) return;
    var repairSichtbar = false;
    var sync = function () {
      var an = (sticky && sticky.classList.contains('sticky--visible')) || repairSichtbar;
      document.body.classList.toggle('iv-sticky-visible', an);
    };
    sync();
    if (sticky) new MutationObserver(sync).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    if (repair && 'IntersectionObserver' in window) {
      /* Ein Beobachter fuer jeden Grund, aus dem die Leiste kommt oder geht: eigenes hidden,
         verstecktes Elternelement (Startseite, Tabwechsel) und die Breitenregel ab 768 px. */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { repairSichtbar = entry.isIntersecting; });
        sync();
      }, { threshold: 0 }).observe(repair);
    }
    if (!sticky) return;
    sticky.addEventListener('click', function (event) {
      var btn = event.target.closest('.iv-sticky-buy[data-iv-open]');
      if (!btn) return;
      event.preventDefault();
      var inner = sticky.querySelector('.product-add-to-cart-sticky--inner');
      var content = sticky.querySelector('.product-add-to-cart-sticky--content');
      if (inner && content && !content.classList.contains('active') && !inner.classList.contains('sticky-open')) inner.click();
      window.setTimeout(function () {
        var first = content && content.querySelector('input:not([type="hidden"]), select, button');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
      }, 320);
    });
  }

  /* Footer im Viewport */
  function watchFooter() {
    var footer = document.getElementById('footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.body.classList.toggle('iv-footer-inview', entry.isIntersecting);
      });
    }, { threshold: 0 }).observe(footer);
  }

  /* Footer-Akkordeon: mobil eine echte Schaltflaeche, ab 768 px keine mehr.
     Block D (17.09.2026): Bis dahin blieb die Ueberschrift auf jeder Breite fokussierbar und
     klickbar, obwohl sie ab 768 px nichts mehr schaltet (die Liste steht dort dauerhaft offen,
     der Pfeil ist ausgeblendet). Jetzt wird der Zustand bei jedem Breitenwechsel nachgefuehrt:
     mobil Schaltflaeche mit aria-expanded, darueber aus der Tabreihenfolge genommen und als
     nicht bedienbar gekennzeichnet. Das Klicken selbst sperrt assets/footer.css. */
  function footerAccordion() {
    var buttons = document.querySelectorAll('.footer .thb-widget-title.collapsible');
    if (!buttons.length) return;
    var listen = [];
    Array.prototype.forEach.call(buttons, function (button) {
      var widget = button.closest('.widget');
      var list = widget && widget.querySelector('.thb-widget-menu');
      if (!list) return;
      if (!list.id) list.id = 'iv-footer-menu-' + Math.random().toString(36).slice(2, 8);
      button.setAttribute('aria-controls', list.id);
      listen.push({ button: button, list: list });
      button.addEventListener('click', function () {
        window.setTimeout(function () {
          var open = button.classList.contains('active');
          list.classList.toggle('iv-open', open);
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        }, 0);
      });
    });

    var breit = window.matchMedia('(min-width: 768px)');
    function zustand() {
      listen.forEach(function (eintrag) {
        if (breit.matches) {
          // Keine Schaltflaeche mehr: kein Fokus, kein Zustand, nichts zu erweitern.
          eintrag.button.setAttribute('tabindex', '-1');
          eintrag.button.setAttribute('aria-disabled', 'true');
          eintrag.button.removeAttribute('aria-expanded');
        } else {
          eintrag.button.removeAttribute('tabindex');
          eintrag.button.removeAttribute('aria-disabled');
          eintrag.button.setAttribute('aria-expanded', eintrag.button.classList.contains('active') ? 'true' : 'false');
        }
      });
    }
    if (breit.addEventListener) breit.addEventListener('change', zustand);
    else if (breit.addListener) breit.addListener(zustand);
    zustand();
  }

  function init() {
    watchDialogs();
    watchSticky();
    watchFooter();
    footerAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Paket B / F-053 (27.09.2026): Per Tastatur fokussierte Elemente nicht unter dem festen Seitenkopf bzw. der
 * klebenden Uebersichtsleiste im Ankauf verstecken (WCAG 2.4.11). Beim Tabben scrollt der Browser nur bis an die
 * Fensterkante - dort liegen der Kopf (mobil 66 px, Desktop 74 px) und mobil die Leiste "x Angaben bis zum Angebot".
 * Bewusst kein seitenweites scroll-padding: es wuerde sich mit den vorhandenen scroll-margin-Abstaenden (Ankauf,
 * Formulare, Produktseite) verdoppeln. Wirkt nur bei Tastaturfokus (:focus-visible) und nur, wenn etwas verdeckt ist.
 */
(function () {
  'use strict';
  if (window.ivFocusReserveReady) return;
  window.ivFocusReserveReady = true;
  var ABSTAND = 12;

  function klebend(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      var p = window.getComputedStyle(e).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  }

  function reserve(el) {
    var oben = 0;
    var kopf = document.querySelector('theme-header');
    var huelle = kopf && (kopf.closest('.header-section') || kopf);
    if (huelle) {
      var stil = window.getComputedStyle(huelle);
      if ((stil.position === 'sticky' || stil.position === 'fixed') && stil.visibility !== 'hidden') {
        var k = kopf.getBoundingClientRect();
        if (k.bottom > 0 && k.top < window.innerHeight / 2) oben = Math.max(oben, k.bottom);
      }
    }
    // Review 27.09.: Die Uebersichtsleiste zaehlt nur, wenn sie wirklich angedockt ist und das Element im Dokument
    // nach ihr kommt - eine lose weiter unten stehende Leiste verdeckt nichts darueber.
    Array.prototype.forEach.call(document.querySelectorAll('.smartphone-buyback__mobile-summary'), function (leiste) {
      if (!leiste.getClientRects().length) return;
      if (!(leiste.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      var s = window.getComputedStyle(leiste);
      var r = leiste.getBoundingClientRect();
      var angedockt = s.position === 'fixed' || (s.position === 'sticky' && s.top !== 'auto' && r.top <= parseFloat(s.top) + 1);
      if (angedockt && r.bottom > 0) oben = Math.max(oben, r.bottom);
    });
    return oben;
  }

  document.addEventListener('focusin', function (event) {
    var el = event.target;
    if (!el || el === document.body || el === document.documentElement || typeof el.getBoundingClientRect !== 'function') return;
    try { if (!el.matches(':focus-visible')) return; } catch (e) { return; }
    // Eigene Fokuslogik oder selbst klebend (Kopf, Leisten, Fenster): nichts verschieben.
    if (el.closest('dialog, [role="dialog"], [aria-modal="true"], .side-panel') || klebend(el)) return;
    var grenze = reserve(el);
    if (!grenze) return;
    var r = el.getBoundingClientRect();
    if (r.bottom <= 0 || r.top >= grenze + 2) return;
    // Review 27.09.: sofort statt weich (html { scroll-behavior: smooth }) - ein weiches Scrollen konnte vom Browser
    // ueberschrieben werden und liefe auch bei "Bewegung reduzieren" animiert.
    var root = document.documentElement;
    var vorher = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(window.scrollX, window.scrollY + r.top - grenze - ABSTAND);
    root.style.scrollBehavior = vorher;
  }, true);
})();

/**
 * Paket 1 (04.10.2026): Rueckmeldung, wenn im Warenkorb die Hoechstmenge erreicht ist.
 * Der Mengenwaehler des Themes (assets/app.js, change_quantity) ignoriert den Klick auf "+" stillschweigend,
 * sobald der Wert das max-Attribut erreicht hat - fuer den Kunden passierte nichts. Jetzt erscheint darunter
 * "Nur N Stueck verfuegbar." Die Zeile verschwindet von selbst, sobald der Warenkorb neu gezeichnet wird.
 * Fehler vom Server (Bestand hat sich geaendert) meldet weiter assets/cart.js.
 */
(function () {
  'use strict';
  if (window.ivQtyMaxReady) return;
  window.ivQtyMaxReady = true;

  // Fangphase: laeuft vor dem Klick-Handler des Themes, der Wert ist also noch der alte.
  document.addEventListener('click', function (event) {
    var ziel = event.target;
    var plus = ziel && typeof ziel.closest === 'function' ? ziel.closest('quantity-selector.cart-update .plus') : null;
    if (!plus) return;
    var sel = plus.closest('quantity-selector');
    var input = sel ? sel.querySelector('.qty') : null;
    if (!input || !sel.parentNode) return;
    var max = parseInt(input.getAttribute('max'), 10);
    var wert = parseInt(input.value, 10);
    var schritt = parseInt(input.getAttribute('step'), 10) || 1;
    if (isNaN(max) || isNaN(wert) || max >= wert + schritt) return;
    var hinweis = sel.parentNode.querySelector('.iv-qty-max');
    if (!hinweis) {
      hinweis = document.createElement('p');
      hinweis.className = 'iv-qty-max';
      hinweis.setAttribute('role', 'status');
      sel.parentNode.appendChild(hinweis);
    }
    // Erst leeren, dann setzen: so wird die Meldung auch beim erneuten Tippen angesagt.
    hinweis.textContent = '';
    window.setTimeout(function () {
      hinweis.textContent = 'Nur ' + max + ' Stück verfügbar.';
    }, 30);
  }, true);
})();
